/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isRightToLeft } from 'js/lib/language';

import { Typography2 } from '@coursera/cds-core';

import CoachButton from 'bundles/unified-description-page-common/components/coach/CoachButton';

import _t from 'i18n!nls/xdp';

const styles = {
  coachButtonContainer: ({ isRTL = false }: { isRTL: boolean }) => css`
    display: inline-flex;
    gap: var(--cds-spacing-100);
    background: ${isRTL
      ? 'linear-gradient(90deg, rgb(53 135 252 / 40%) 0%, rgb(15 240 255 / 20%) 100%)'
      : 'linear-gradient(90deg, rgb(15 240 255 / 20%) 0%, rgb(53 135 252 / 40%) 100%)'};
    border-radius: var(--cds-border-radius-max);
    padding-top: var(--cds-spacing-50);
    padding-bottom: var(--cds-spacing-50);
    padding-right: var(--cds-spacing-50);
    padding-left: var(--cds-spacing-200);
    align-items: center;
    justify-content: start;
  `,
  coachButton: css`
    .cds-button-label {
      white-space: nowrap;
    }
  `,
};

const CoachButtonInHeroModule = () => {
  const isRTL = isRightToLeft(_t.getLocale());

  return (
    <div css={styles.coachButtonContainer({ isRTL })}>
      <Typography2 component="p" variant="subtitleSmall">
        {_t('Ask Coursera')}
      </Typography2>
      <CoachButton css={styles.coachButton} />
    </div>
  );
};

export default CoachButtonInHeroModule;
